// @flow
import React, { Component } from 'react';
import capitalize from 'capitalize';
import { Table, thead, th, tr } from 'react-bootstrap';
import UserRow from './components/UserRow/UserRow';
import locale from '../../../../locales/index';
import style from './style';
import api from '../../../../services/api';

class UsersList extends Component<{
  onUserSelect: Function,
  filter: string,
}, {
  users: Array<Object>,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      users: [],
    };
  }

  componentWillMount() {
    api.users.getList((res) => { this.onUsersLoaded(res); });
  }

  componentWillReceiveProps(nextProps: Object) {
    if (nextProps.filter !== this.props.filter) {
      api.users.search(nextProps.filter, (res) => { this.onUsersLoaded(res); });
    }
  }

  onUsersLoaded(list: Array<Object>) {
    list.sort(this.compareName);
    this.setState({ users: list });
  }

  compareName(a: Object, b: Object): number {
    if (a.profile.name.givenName < b.profile.name.givenName) {
      return -1;
    }
    if (a.profile.name.givenName > b.profile.name.givenName) {
      return 1;
    }
    return 0;
  }

  render() {
    const rows = [];
    this.state.users.forEach((user) => {
      const profile = user.profile;
      const place = (profile.placesLived !== undefined && profile.placesLived.length > 0) ? profile.placesLived[0].value : '';

      rows.push(<UserRow
        name={capitalize.words(`${profile.name.givenName} ${profile.name.familyName}`)}
        gender={profile.gender}
        residence={place}
        groups=""
        image={profile.image.url}
        key={user.id}
        onClick={() => this.props.onUserSelect(user.id)}
      />);
    });

    return (
      <Table responsive hover style={style.tableStyle}>
        <thead>
          <tr>
            <th>#</th>
            <th>{locale.name}</th>
            <th>{locale.gender}</th>
            <th>{locale.residence}</th>
            <th>{locale.groups}</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </Table>
    );
  }
}

export default UsersList;



// WEBPACK FOOTER //
// ./src/scenes/Users/components/UserList/UsersList.js